// routes
import { PATH_SALES } from "../../../routes/paths";
// components
import SvgColor from "../../../components/svg-color";

// ----------------------------------------------------------------------

const icon = (name: string) => (
  <SvgColor
    src={`/assets/icons/navbar/${name}.svg`}
    sx={{ width: 1, height: 1 }}
  />
);

const ICONS = {
  blog: icon("ic_blog"),
  cart: icon("ic_cart"),
  chat: icon("ic_chat"),
  mail: icon("ic_mail"),
  user: icon("ic_user"),
  file: icon("ic_file"),
  lock: icon("ic_lock"),
  label: icon("ic_label"),
  blank: icon("ic_blank"),
  kanban: icon("ic_kanban"),
  folder: icon("ic_folder"),
  banking: icon("ic_banking"),
  booking: icon("ic_booking"),
  invoice: icon("ic_invoice"),
  calendar: icon("ic_calendar"),
  disabled: icon("ic_disabled"),
  external: icon("ic_external"),
  menuItem: icon("ic_menu_item"),
  ecommerce: icon("ic_ecommerce"),
  analytics: icon("ic_analytics"),
  dashboard: icon("ic_dashboard"),
  invitation: icon("ic_invitation"),
  commission: icon("ic_commission"),
  leads: icon("af_leads"),
};

const navConfig = [
  // GENERAL
  // ----------------------------------------------------------------------
  {
    subheader: "general",
    items: [
      {
        title: "Dashboard",
        path: PATH_SALES.dashboard,
        icon: ICONS.dashboard,
      },
      {
        title: "Affiliate",
        path: PATH_SALES.inviteAffiliateUser,
        icon: ICONS.user,
      },
      {
        title: "My Team",
        path: PATH_SALES.team,
        icon: ICONS.user,
      },
      {
        title: "Performance",
        path: PATH_SALES.performance,
        icon: ICONS.user,
      },
      {
        title: "Leads",
        path: PATH_SALES.leads,
        icon: ICONS.leads,
      },
      {
        title: "Profile",
        path: PATH_SALES.profile,
        icon: ICONS.banking,
      },
    ],
  },
  //       path: PATH_DASHBOARD.user.root,
  //       icon: ICONS.user,
  //       children: [
  //         { title: "Four", path: PATH_DASHBOARD.user.four },
  //         { title: "Five", path: PATH_DASHBOARD.user.five },
  //         { title: "Six", path: PATH_DASHBOARD.user.six },
  //       ],
  //     },
  //   ],
  // },
];

export default navConfig;
